import React, { useState, useEffect } from 'react';
import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from '../firebase-config';

const BlogPosts = () =>
{
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() =>
  {
    const fetchPosts = async () =>
    {
      try
      {
        const q = query(
          collection(db, "blogs"),
          orderBy("submittedAt", "desc"),
          limit(10)
        );

        const snapshot = await getDocs(q);

        const blogPosts = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        setPosts(blogPosts);
      }
      catch (err)
      {
        console.error(err);
        setError('Failed to fetch blog posts. Please try again later.');
      }
      finally
      {
        setIsLoading(false);
      }
    };

    fetchPosts();
  }, []);

  return (
    <div className="bg-white dark:bg-gray-900 px-2">

      {/* SECTION HEADER */}
      <h2
        className="
          text-xl
          sm:text-2xl
          lg:text-3xl
          font-bold
          mb-3
          text-black
          dark:text-white
        "
      >
        Educational Blogs
      </h2>

      {/* CONTENT */}
      {
        isLoading ? (
          <div className="text-center text-base sm:text-xl font-medium text-gray-400">
            Loading blog posts...
          </div>
        ) : error ? (
          <div className="text-center text-base sm:text-xl font-medium text-red-500">
            {error}
          </div>
        ) : posts.length > 0 ? (
          <div className="space-y-2 sm:space-y-6">
            {posts.map(post => (
              <div
                key={post.id}
                className="bg-gray-900 rounded-xl shadow-md p-4 sm:p-6 border border-white"
              >
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-2 mb-2">
                  <h3 className="text-lg sm:text-xl lg:text-2xl font-semibold text-white break-words">
                    {post.title}
                  </h3>

                  <span className="text-xs sm:text-sm font-bold px-3 py-1 rounded-full bg-green-600 text-white w-fit">
                    Blog
                  </span>
                </div>

                <p className="text-sm sm:text-md text-gray-300 mb-3 sm:mb-4">
                  By {post.userName} on{" "}
                  {post.submittedAt.toDate().toLocaleString()}
                </p>

                <p className="text-base sm:text-lg text-white leading-relaxed whitespace-pre-wrap break-words">
                  {post.content}
                </p>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center p-6 sm:p-10 bg-white dark:bg-gray-800 rounded-lg shadow-md">
            <p className="text-base sm:text-xl font-medium text-black dark:text-white">
              No blog posts yet. Check back soon!
            </p>
          </div>
        )
      }
    </div>
  );
};

const Blog = () =>
{
  return (
    <div className="container mx-auto mt-1 sm:mt-6 px-1 sm:px-4 mb-1">
      <div className="w-full">
        <BlogPosts />
      </div>
    </div>
  );
};

export default Blog;